module.exports = __webpack_public_path__ + "img/bea09c4ba75cd99c1c1e2f28b0a30966.9fb593e6.png";